import React from 'react';
import { func, oneOf } from 'prop-types';
import SurveyList from './SurveyList';
import { surveyTypeValues } from '../../constants/types';
import { withLang } from '../../i18n';
import useTitle from '../../hooks/useTitle';

const surveyTypes = Object.values(surveyTypeValues);

const ManageSurveys = ({ type, translate }) => {
  const surveyListTitle = () => {
    switch (type) {
      case surveyTypeValues.COURSE_SURVEY:
        return translate('manageSurveys.husSurveys');
      case surveyTypeValues.HUP:
        return translate('manageSurveys.hupSurveys');
      case surveyTypeValues.HUT:
        return translate('manageSurveys.hutSurveys');
      default:
        return translate('manageSurveys.hulSurveys');
    }
  };

  useTitle(surveyListTitle());

  return (
    <div className="page-container">
      <SurveyList type={type} title={surveyListTitle()} />
    </div>
  );
};

ManageSurveys.propTypes = {
  translate: func.isRequired,
  type: oneOf(surveyTypes).isRequired
};

export default withLang(ManageSurveys);
